/**
 * /affiliates/manager — affiliate-manager assignment page.
 */
import { createRoute, Link } from "@tanstack/react-router";
import { rootRoute } from "./__root";
import { AffiliateManagerPage } from "@/features/affiliate-manager/AffiliateManagerPage";

export const affiliatesManagerRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/affiliates/manager",
	component: AffiliatesManagerRoute,
});

export default affiliatesManagerRoute;

export function AffiliatesManagerRoute() {
	return (
		<div className="mx-auto flex w-full max-w-5xl flex-col gap-4 px-6 pt-6 sm:pt-10">
			<Breadcrumb />
			<AffiliateManagerPage />
		</div>
	);
}

function Breadcrumb() {
	return (
		<nav aria-label="Breadcrumb" className="text-sm text-zinc-500">
			<ol className="flex flex-wrap items-center gap-1">
				<li>
					<Link
						to="/"
						className="rounded-[6px] px-1 py-0.5 hover:bg-zinc-100 hover:text-zinc-900"
					>
						Dashboard
					</Link>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li>
					<span className="rounded-[6px] px-1 py-0.5">Affiliates</span>
				</li>
				<li aria-hidden="true" className="text-zinc-300">
					/
				</li>
				<li className="text-zinc-900">Manager</li>
			</ol>
		</nav>
	);
}
